import { FC, useState } from 'react';

import RequestContractDetailDialog from '@components_iqfu/dashboard/dialog/request_contract_detail/RequestContractDetail';

import styles from './RequestShowDetailButton.module.scss';

type RequestShowDetailButton = {
  isActive: boolean;
  sellingContractId: number;
};

const RequestShowDetailButton: FC<RequestShowDetailButton> = ({ isActive, sellingContractId }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <>
      <button
        className={`${styles.contract_detail_link} ${isActive ? '' : styles.is_disabled}`}
        onClick={() => setIsModalOpened(true)}
      >
        詳細
      </button>

      <RequestContractDetailDialog
        sellingContaractId={sellingContractId}
        onClose={() => {
          setIsModalOpened(false);
        }}
        open={isModalOpened}
        fullWidth={false}
      />
    </>
  );
};

export default RequestShowDetailButton;
